module.exports = __webpack_public_path__ + "img/background-bottom.16d0b7bd.jpg";